/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "./bootstrap";
import bsCustomFileInput from 'bs-custom-file-input'; // custom file animation for bootstrap 4

window.moment = require("moment-timezone");
window.he = require("he");
window.Vue = require("vue");

require('floatthead');

const dateFns = require('date-fns');

const { format, parse, isValid } = dateFns;

window.number_format = function (number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
        dec = typeof dec_point === "undefined" ? "." : dec_point,
        s = "",
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return "" + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
};

window.byte_format = function (bytes, decimals) {
    if (bytes == 0) return "0 Bytes";
    var k = 1024,
        dm = decimals <= 0 ? 0 : decimals || 2,
        sizes = ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

window.load_file_into_element = function (event, element) {
    var output = document.getElementById(element);
    output.src = URL.createObjectURL(event.target.files[0]);
};

// Get the browser locale for usage with moment.
moment.locale(process.env.MIX_APP_LOCALE_JS);
moment.tz.setDefault(process.env.MIX_APP_TIMEZONE);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component("api-search", require("./components/ApiSearch.vue").default);

Vue.component("enq-row", require("./components/Enquiries/EnqRow.vue").default);

Vue.component(
    "enq-auto-allocate-button",
    require("./components/Enquiries/AutoAllocateButton.vue").default
);
Vue.component(
    "enq-portion-user-allocating",
    require("./components/Enquiries/Portions/UserAllocating.vue").default
);

Vue.component(
    "enq-view",
    require("./components/Enquiries/EnqView.vue").default
);
Vue.component(
    "enq-portion-progress-status",
    require("./components/Enquiries/Portions/ProgressStatus.vue").default
);
Vue.component(
    "enq-portion-notes",
    require("./components/Enquiries/Portions/Notes.vue").default
);
Vue.component(
    "enq-note",
    require("./components/Enquiries/Portions/Note.vue").default
);
Vue.component(
    "enq-portion-uploads",
    require("./components/Enquiries/Portions/Uploads.vue").default
);
Vue.component(
    "enq-upload",
    require("./components/Enquiries/Portions/Upload.vue").default
);
Vue.component(
    "enq-part",
    require("./components/Enquiries/Portions/Part.vue").default
);
Vue.component(
    "enq-portion-additional-costs",
    require("./components/Enquiries/Portions/AdditionalCosts.vue").default
);
Vue.component(
    "enq-additional-cost",
    require("./components/Enquiries/Portions/AdditionalCost.vue").default
);

Vue.component(
    "enq-fragment-details",
    require("./components/Enquiries/Fragments/Details.vue").default
);
Vue.component(
    "enq-fragment-company",
    require("./components/Enquiries/Fragments/Company.vue").default
);
Vue.component(
    "enq-fragment-parts",
    require("./components/Enquiries/Fragments/Parts.vue").default
);
Vue.component(
    "enq-fragment-quotation",
    require("./components/Enquiries/Fragments/Quotation.vue").default
);
Vue.component(
    "enq-fragment-documents",
    require("./components/Enquiries/Fragments/Documents.vue").default
);
Vue.component(
    "enq-fragment-invoice",
    require("./components/Enquiries/Fragments/Invoice.vue").default
);
Vue.component(
    "enq-fragment-proforma",
    require("./components/Enquiries/Fragments/Proforma.vue").default
);
Vue.component(
    "enq-fragment-order-confirmation",
    require("./components/Enquiries/Fragments/OrderConfirmation.vue").default
);
Vue.component(
    "enq-fragment-delivery-note",
    require("./components/Enquiries/Fragments/DeliveryNote.vue").default
);
Vue.component(
    "enq-fragment-lost",
    require("./components/Enquiries/Fragments/Lost.vue").default
);
Vue.component(
    "enq-fragment-purchase-order",
    require("./components/Enquiries/Fragments/PurchaseOrder.vue").default
);
Vue.component(
    "admin-part-search",
    require("./components/AdminPartSearch.vue").default
);

//const files = require.context('./', true, /\.vue$/i);
//files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

/**
 * Current time in a locale format DATE TIME(+SECONDS)
 */
function timestamp() {
    const d = new Date();

    return d.toLocaleDateString() + ' @ ' + format(d, 'pp');
}

$("#current-time").text(timestamp());
setInterval(function () {
    $("#current-time").text(timestamp());
}, 1000);

/**
 * Clickable table rows.
 */
window.make_tables_clickable = function () {
    $(".table tr[data-href] td:not([data-prevent-click])").each(function () {
        $(this)
            .css("cursor", "pointer")
            .hover(
                function () {
                    $(this).addClass("active");
                },
                function () {
                    $(this).removeClass("active");
                }
            )
            .click(function (e) {
                document.location = $(this)
                    .parent()
                    .attr("data-href");
            });
    });
};

window.make_input_no_0 = function () {
    $('input[type="number"]').each(function () {
        $(this)
            .focus(function (e) {
                let val = $(this).val();

                if (val == 0 || 'on' === $(this).attr('data-always-clear')) {
                    $(this).attr('data-last-val', $(this).val());
                    $(this).val('');
                }
            })
            .blur(function (e) {
                let val = $(this).val();

                if (val == '') {
                    $(this).val($(this).attr('data-last-val') || 0);
                }
            });
    });
}

/**
 * Floating table headers.
 * Accordion by ID.
 */
$(document).ready(function () {
    $($(window.location.hash).attr('data-target')).collapse('show');

    $('.float-thead').floatThead();
    make_tables_clickable();
    make_input_no_0();

    // Init custom file upload animation
    // for some reason this is non-standard...
    bsCustomFileInput.init();

    function countryChange() {
        if (this.value === 'US') {
            $('.hide-if-not-usa').show();
            $('.required-if-usa').prop('required', true);
        } else {
            $('.hide-if-not-usa').hide();
            $('.required-if-usa').prop('required', false);
        }
    }

    $('select[name="countryCode"], select[name="branch[countryCode]"]').change(countryChange);

    function slug(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to = "aaaaeeeeiiiioooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return str;
    }

    var current = $('select[name="countryCode"], select[name="branch[countryCode]"]').first().val();
    if (current === 'US') {
        $('.hide-if-not-usa').show();
        $('.required-if-usa').prop('required', true);
    } else {
        $('.hide-if-not-usa').hide();
        $('.required-if-usa').prop('required', false);
    }

    $('#manufacturerID').change(function () {
        let val = $(this).find("option:selected").text();
        let partNo = $('#partNo').val();
        let sl = slug(partNo).replace(/[-]/g, '');

        if (sl == partNo) {
            sl = '';
        } else {
            sl = ' (' + sl + ')';
        }

        val = val + ' ' + partNo + sl;
        console.log(val);

        $('#description').val(val);
    });
});


/**
 * Translations from php.
 */
window.__ = (string, args) => {
    let value = _.get(window.i18n, string);
    value = _.isEmpty(value) ? string : value;

    _.eachRight(args, (arg, key) => {
        value = _.replace(value, `:${key}`, arg);
    });

    return value;
};

window.DEFAULT_CURRENCY_ID = parseInt(process.env.MIX_DEFAULT_CURRENCY_ID);
window.MARGIN_PERCENTAGE = parseInt(process.env.MIX_MARGIN_PERCENTAGE);

window.APP_LOCALE = process.env.MIX_APP_LOCALE_JS;
window.STOCK_BUY_MULT = parseFloat(process.env.MIX_STOCK_BUY_MULT);

switch (window.DEFAULT_CURRENCY_ID) {
    default:
    case 1:
        window.DEFAULT_CURRENCY_CURRENCY = 'GBP';
        window.DEFAULT_CURRENCY_SYMBOL = '£';
        break;
    case 2:
        window.DEFAULT_CURRENCY_CURRENCY = 'EUR';
        window.DEFAULT_CURRENCY_SYMBOL = '€';
        break;
    case 3:
        window.DEFAULT_CURRENCY_CURRENCY = 'USD';
        window.DEFAULT_CURRENCY_SYMBOL = '$';
        break;
}

/**
 * Mixin translations for entire app.
 */
Vue.mixin({
    methods: {
        __: __,
    },

    computed: {
        DEFAULT_CURRENCY_ID: () => DEFAULT_CURRENCY_ID,
        DEFAULT_CURRENCY_SYMBOL: () => DEFAULT_CURRENCY_SYMBOL,
        DEFAULT_CURRENCY_CURRENCY: () => DEFAULT_CURRENCY_CURRENCY,
        MARGIN_PERCENTAGE: () => MARGIN_PERCENTAGE,
        STOCK_BUY_MULT: () => STOCK_BUY_MULT,
        APP_LOCALE: () => APP_LOCALE,
        authed: () => authed,
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#app",

    data: {
        moment: moment,
        he: he
    },
});

